import { use } from 'react'
import { ChatSessionContext } from '../contexts/ChatSessionContext'

export function useChatSession() {
  const context = use(ChatSessionContext)
  if (!context) {
    throw new Error('useChatSession must be used within ChatSessionProvider')
  }
  return context
}
